import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { reduxForm, Field, getFormValues } from 'redux-form'
import '../form.scss'
import { Fields } from './types'
import InputField from '@App/components/fields/InputField'
// @ts-ignore
import { Button } from 'relevant-ui'
import SelectField from '@App/components/fields/SelectField'
import { ROLE_VALUES } from '@App/constantes'

class NewSegementForm extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    const data = {
      ...this.props.segmentFormValues,
      minimumRoleValue: this.props.segmentFormValues.minimumRoleValue.value,
    }

    this.props.onSubmit(e, data, this.props.editSegment?.id)
  }

  render() {
    const { t, canceled, segmentFormValues } = this.props

    const desabled = segmentFormValues
      ? Object.keys(segmentFormValues)?.length !== 3
      : true

    return (
      <form className="form" style={{ padding: '3.9rem 5.7rem' }}>
        <h2 className="title">{t('add_segment')}</h2>
        <div className="form__field form__field--large">
          <div className="form__field__label">
            {t('Name')}
          </div>
          <div className="form__field__input">
            <Field
              name={Fields.NAME}
              component={InputField}
              label="Name"
              placeholder="Name..."
              secondary
            />
          </div>
        </div>
        <div className="form__field form__field--large">
          <div className="form__field__label">
            {t('label')}
          </div>
          <div className="form__field__input">
            <Field
              name={Fields.LABEL}
              component={InputField}
              label="Label"
              placeholder="Label..."
              secondary
            />
          </div>
        </div>
        <div className="form__field form__field--large">
          <div className="form__field__label">
            {t('Role')}
          </div>
          <div className="form__field__input">
            <Field
              name={Fields.ROLE}
              component={SelectField}
              options={ROLE_VALUES}
              placeholder="Minimun role value ..."
              onBlur={(e: any) => e.preventDefault()}
              secondary
            />
          </div>
        </div>
        <div className="buttons mt-20">
          <Button
            type="submit"
            label={t('validate')}
            size="large"
            onClick={(e: any) => this.handleClick(e)}
            button="primary"
            disabled={desabled}
          />
          <Button
            className="button secondary large ml-20"
            label={t('cancel')}
            onClick={canceled}
          />
        </div>
      </form>
    )
  }
}

const SegmentForm = reduxForm({
  form: Fields.SEGMENT,
  enableReinitialize: true,
})(NewSegementForm as any)

const mapStateToProps = (state: any, props) => {
  const segmentFormValues = getFormValues(Fields.SEGMENT)(state)
  const { editSegment } = props

  let initialValues = {}

  if (editSegment) {
    initialValues = {
      [Fields.NAME]: editSegment.name || '',
      [Fields.LABEL]: editSegment.label || '',
      [Fields.ROLE]: {
        label: editSegment.minimumRoleValue, value: editSegment.minimumRoleValue,
      } || '',
    }
  }

  return {
    segmentFormValues,
    initialValues,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(SegmentForm)
